import { useState, useEffect } from 'react';
import classnames from 'classnames';
import './index.less';
import { SvgIcon } from '../SvgIcon';

export interface PaginationProps {
  defaultCurrent?: number;
  defaultPageSize?: number;
  total: number;
  onChange?: (current: number, pageSize?: number) => void;
}

const calcTotalPage = (total: number, pageSize: number) => {
  return Math.ceil(total / pageSize);
};

export function Pagination(
  props: PaginationProps & Omit<React.HTMLAttributes<HTMLElement>, 'onChange'>,
) {
  const {
    className,
    defaultCurrent,
    defaultPageSize,
    total,
    onChange,
    ...otherProps
  } = props;

  const [current, setCurrent] = useState<number>(defaultCurrent || 1);
  const [pageSize] = useState<number>(defaultPageSize || 10);
  const [totalPage, setTotalPage] = useState<number>(
    calcTotalPage(total, pageSize),
  );

  const changeCurrent = (newCurrent: number) => {
    if (newCurrent !== current) {
      setCurrent(newCurrent);
      onChange && onChange(newCurrent);
    }
  };

  const handlePrevClick = () => {
    const newCurrent = current - 1 > 0 ? current - 1 : 1;
    changeCurrent(newCurrent);
  };
  const handleNextClick = () => {
    const newCurrent = current + 1 > totalPage ? totalPage : current + 1;
    changeCurrent(newCurrent);
  };

  useEffect(() => {
    setTotalPage(calcTotalPage(total, pageSize));
  }, [total, pageSize]);

  return (
    <div className={classnames('mag-pagination', className)} {...otherProps}>
      <span
        className={classnames('mag-pagination-item', 'pager', {
          disabled: current <= 1,
        })}
        onClick={handlePrevClick}
      >
        <SvgIcon name="collapse" className="flipx" />
      </span>
      <span
        className={classnames('mag-pagination-item', 'page', {
          disabled: totalPage <= 0,
        })}
      >
        {current} / {totalPage}
      </span>
      <span
        className={classnames('mag-pagination-item', 'pager', {
          disabled: current >= totalPage,
        })}
        onClick={handleNextClick}
      >
        <SvgIcon name="collapse" />
      </span>
    </div>
  );
}
